import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { SortDropdown } from "./sortDropdown";
import { Props } from "./types";
import styles from "./styles.scss";

function Toolbar({ filter, sort, setFilter, setSort }: Props) {
  const { t } = useTranslation();
  const { resources, roles, organizationalUnits } = filter;

  return (
    <div className={styles.toolbar}>
      <div className={styles.section}>
        <p className={styles.title}>{t("zonePage.projects.sorter.title")}</p>
        <div className={styles.sort}>
          <SortDropdown selectedSort={sort} setSelectedSort={setSort} />
        </div>
      </div>
      <div className={styles.section}>
        <p className={styles.title}>{t("zonePage.projects.filters.title")}</p>
        <div className={styles.filter}>
          <FilterMenu
            filter={filter}
            placeholder={t("zonePage.projects.filters.placeholderZone")}
            views={[
              "projects",
              "projectStatuses",
              "projectPortfolios",
              "projectsTags",
            ]}
            setFilter={(nextFilter) =>
              setFilter({
                ...nextFilter,
                resources,
                roles,
                organizationalUnits,
              })
            }
          />
        </div>
      </div>
      <div className={styles.section}>
        <p className={styles.title}>
          {t("zonePage.projects.filters.showProjectsOf")} :
        </p>
        <div className={styles.filter}>
          <FilterMenu
            filter={filter}
            placeholder={t("zonePage.projects.filters.placeholderResource")}
            views={["resources", "roles", "organizationalUnits"]}
            openedViews={["resources"]}
            roleScope="project"
            setFilter={(nextFilter) =>
              setFilter({
                ...filter,
                resources: nextFilter.resources,
                roles: nextFilter.roles,
                organizationalUnits: nextFilter.organizationalUnits,
              })
            }
          />
        </div>
      </div>
    </div>
  );
}

export { Toolbar };
